// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3dFie","label":"Labeled_label__23Kw3","divider":"Labeled_divider__w6XFI"};